import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { LicenseSw, LicenseSwType, LicenseSwAddParam } from '../license-mgt.model';

export enum LicenseSwActionTypes {
  GetLicenseSw = '[LicenseSw] Get LicenseSw',
  GetLicenseSwList = '[LicenseSw] Get LicenseSw List',
  GetLicenseSwType = '[LicenseSw] Get LicenseSw Type',
  GetAddLicenseSw = '[LicenseSw] Get Add LicenseSw',
  GetUpdateLicenseSw = '[LicenseSw] Get Update LicenseSw',
  GetDeleteLicenseSw = '[LicenseSw] Get Delete LicenseSw',
  GetConfirmLicenseSw = '[LicenseSw] Get Confirm LicenseSw',
  LoadLicenseSw = '[LicenseSw] Load LicenseSw',
  LoadLicenseSwList = '[LicenseSw] Load LicenseSw List',
  LoadLicenseSwType = '[LicenseSw] Load LicenseSw Type',
  AddLicenseSw = '[LicenseSw] Add LicenseSw',
  UpsertLicenseSw = '[LicenseSw] Upsert LicenseSw',
  UpsertLicenseSws = '[LicenseSw] Upsert LicenseSws',
  UpdateLicenseSw = '[LicenseSw] Update LicenseSw',
  DeleteLicenseSw = '[LicenseSw] Delete LicenseSw',
  ClearLicenseSws = '[LicenseSw] Clear LicenseSws',
  GetLicenseSwFail = '[LicenseSw] Get LicenseSw Fail',
  GetLicenseSwListFail = '[LicenseSw] Get LicenseSw List Fail',
  GetLicenseSwTypeFail = '[LicenseSw] Get LicenseSw Type Fail',
  GetAddLicenseSwFail = '[LicenseSw] Get Add LicenseSw Fail',
  GetUpdateLicenseSwFail = '[LicenseSw] Get Update LicenseSw Fail',
  GetDeleteLicenseSwFail = '[LicenseSw] Get Delete LicenseSw Fail',
  SendLicenseSwMail = '[LicenseSw] Send LicenseSw Mail',
  ConfirmLicenseSw = '[LicenseSw] Confirm LicenseSw'
}

export class GetLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.GetLicenseSw;
  constructor(public payload: { Id: number }) {}
}

export class GetLicenseSwList implements Action {
  readonly type = LicenseSwActionTypes.GetLicenseSwList;
  constructor(public payload: any = null) {}
}

export class GetLicenseSwType implements Action {
  readonly type = LicenseSwActionTypes.GetLicenseSwType;
  constructor(public payload: any = null) {}
}

export class GetAddLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.GetAddLicenseSw;
  constructor(public payload: { licenseSw: LicenseSwAddParam }) {}
}

export class GetUpdateLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.GetUpdateLicenseSw;
  constructor(public payload: { licenseSw: LicenseSwAddParam }) {}
}

export class GetDeleteLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.GetDeleteLicenseSw;
  constructor(public payload: { id: string }) {}
}

export class GetConfirmLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.GetConfirmLicenseSw;
  constructor(public payload: { licenseKey: string }) {}
}

export class LoadLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.LoadLicenseSw;
  constructor(public payload: { licenseSws: LicenseSw }) {}
}

export class LoadLicenseSwList implements Action {
  readonly type = LicenseSwActionTypes.LoadLicenseSwList;
  constructor(public payload: { licenseSws: LicenseSw[] }) {}
}

export class LoadLicenseSwType implements Action {
  readonly type = LicenseSwActionTypes.LoadLicenseSwType;
  constructor(public payload: { licenseSwTypes: LicenseSwType[] }) {}
}

export class AddLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.AddLicenseSw;
  constructor(public payload: { licenseSw: LicenseSw }) {}
}

export class UpsertLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.UpsertLicenseSw;
  constructor(public payload: { licenseSw: LicenseSw }) {}
}

export class UpsertLicenseSws implements Action {
  readonly type = LicenseSwActionTypes.UpsertLicenseSws;
  constructor(public payload: { licenseSws: LicenseSw[] }) {}
}

export class UpdateLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.UpdateLicenseSw;
  constructor(public payload: { licenseSw: Update<LicenseSw> }) {}
}

export class DeleteLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.DeleteLicenseSw;
  constructor(public payload: { id: string }) {}
}

export class ClearLicenseSws implements Action {
  readonly type = LicenseSwActionTypes.ClearLicenseSws;
}

export class GetLicenseSwFail implements Action {
  readonly type = LicenseSwActionTypes.GetLicenseSwFail;
}
export class GetLicenseSwListFail implements Action {
  readonly type = LicenseSwActionTypes.GetLicenseSwListFail;
}
export class GetLicenseSwTypeFail implements Action {
  readonly type = LicenseSwActionTypes.GetLicenseSwTypeFail;
}
export class GetAddLicenseSwFail implements Action {
  readonly type = LicenseSwActionTypes.GetAddLicenseSwFail;
}
export class GetUpdateLicenseSwFail implements Action {
  readonly type = LicenseSwActionTypes.GetUpdateLicenseSwFail;
}
export class GetDeleteLicenseSwFail implements Action {
  readonly type = LicenseSwActionTypes.GetDeleteLicenseSwFail;
}
export class SendLicenseSwMail implements Action {
  readonly type = LicenseSwActionTypes.SendLicenseSwMail;
  constructor(public payload: { id: string }) {}

}
export class ConfirmLicenseSw implements Action {
  readonly type = LicenseSwActionTypes.ConfirmLicenseSw;
  constructor(public payload: { licenseKey: string }) {}

}

export type LicenseSwActions =
 GetLicenseSw
 | GetLicenseSwList
 | GetLicenseSwType
 | GetAddLicenseSw
 | GetUpdateLicenseSw
 | GetDeleteLicenseSw
 | GetConfirmLicenseSw
 | LoadLicenseSw
 | LoadLicenseSwList
 | LoadLicenseSwType
 | AddLicenseSw
 | UpsertLicenseSw
 | UpsertLicenseSws
 | UpdateLicenseSw
 | DeleteLicenseSw
 | ClearLicenseSws
 | GetLicenseSwFail
 | GetLicenseSwListFail
 | GetLicenseSwTypeFail
 | GetAddLicenseSwFail
 | GetUpdateLicenseSwFail
 | GetDeleteLicenseSwFail
 | SendLicenseSwMail
 | ConfirmLicenseSw;
